export default {
    "Decentralization":"去中心化",
    "Coin-based":"币本位",
    "Perpetual Options":"永续期权",
    "Future Derivatives Infrastructure":"未来的衍生品基础设施",
    "Start Trading":"开始交易",
    "Trading":"交易",
    "Follow":"跟单交易",
    "Fund Pool":"资金池",
    "Recommendation Reward":"推荐奖励",
    "Language":"语言",
    "Never Liquidate":"永不爆仓",
    "Eliminate Liquidation Risk":"消除爆仓风险",
    "Risk Management Easier":"风险管理更简单",
    "High Leverage":"高杠杆",
    "Multiple Leverage":"倍高倍杠杆",
    "High Profit Potential":"收益潜力大",
    "Zero Slippage":"零滑点",
    "Execution Price Meets Expected Results":"执行价格符合预期结果",
    "Eliminate Impermanent Loss":"消除无常损失",
    "Commission Rate 15%":"佣金率50%",
    "Generous recommendation rewards, recognize your contribution":"丰厚的推荐奖励，认可您的贡献",
    "Generous recommendation rewards, recognize your contribution2":"丰厚的推荐奖励<br/>认可您的贡献",
    "Invite a friend":"邀请朋友",
    "Invite a friend to Fufuture via a referral link":"通过推荐链接邀请朋友加入Fufuture",
    "Friend completes first order":"朋友完成首单",
    "Friend accepts invitation and completes first order":"朋友接受邀请并完成首次订单",
    "Get your commission":"领取您的佣金",
    "Get your commission immediately and claim it anytime":"立即获得您的佣金，随时可领取",
    "Create my link":"创建我的链接",
    "Deep liquidity supported by dual pools":"双池支持的深度流动性",
    "Public pool":"公共池",
    "Available liquidity":"可用流动资金",
    "Private pool":"私有池",
    "Add LP":"添加LP",
    "FAQ":"常见问题解答",
    "Future Derivatives Infrastructure2":"未来衍生性商品的基础设施",
    "Dual liquidity pool":"双流动性池",
    "Open liquidity pool":"开放式流动性池",
    "More stable liquidity":"流动性更稳定",
    "Reasonable pricing":"定价合理",
    "Price feed from third-party oracle":"三方预言机喂价",
    "Precise error control":"误差控制精准",
    "BTC 24-hour trading volume summary":"BTC24小时交易量汇总",
    "BTC holdings summary":"BTC持仓量汇总",
    "ETH 24-hour trading volume summary":"ETH24小时交易量汇总",
    "ETH holdings summary":"ETH持仓量汇总",
    "q1":"我如何增强我的账户安全性？",
    "a1":"交易网站由钱包进入，保护好个人私钥，请勿点击钓鱼链接和扫描未知二维码。",
    "q2":"我如何存款？",
    "a2":"在Fufuture中选择目标代币所在的公链，选择目标代币进行存入操作。",
    "q3":"Fufuture上的交易手续费费是多少？",
    "a3":"永续期权仅收取开仓时的1‰。"

}
